import { defaultFetch } from './baseApi';

type S3Type = {
	uploadUrl: string;
	fileName: string;
	s3Path: string;
};

export const getS3Url = () => {
	return defaultFetch<S3Type>('/upload/init', {
		method: 'POST',
	});
};

export const uploadOnS3 = (uploadUrl: string, file: File, onProgress: (percent: number) => void) => {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();

		xhr.open('PUT', uploadUrl, true);
		xhr.setRequestHeader('Content-Type', 'application/zip');

		xhr.upload.onprogress = (event) => {
			if (event.lengthComputable) {
				const percentCompleted = Math.round((event.loaded * 100) / event.total);
				onProgress(percentCompleted);
			}
		};

		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				resolve(xhr.response); // oppure xhr.responseText
			} else {
				reject(new Error(`Upload fallito con status ${xhr.status}`));
			}
		};

		xhr.onerror = () => reject(new Error("Errore di rete durante l'upload"));
		xhr.onabort = () => reject(new Error('Upload annullato'));

		xhr.send(file);
	});
};

export const notifyCompleteUploadOnS3 = (backendPath: string, s3Path: string, fileName: string) => {
	const body = JSON.stringify({ s3Path, fileName });
	return defaultFetch(`${backendPath}/uploadeddocuments`, {
		method: 'POST',
		body,
	});
};
